import { SOURCE, Source } from "@/constants";
import { Episode } from "@/types/Episode";
import { cx } from "@/utils";

import GenericCover from "./partials/GenericCover";
import InstagramCover from "./partials/InstagramCover";
import TiktokCover from "./partials/TiktokCover";
import YoutubeCover from "./partials/YoutubeCover";

import styles from "./Cover.module.css";

/** Define what aspect ratio the thumbnail of a given source media has */

const SIZES: Record<string, Source[]> = {
  SQUARE: [
    SOURCE.PODCAST,
    SOURCE.RADIO,
    SOURCE.MANUAL,
    SOURCE.TWITTER,
    SOURCE.INSTAGRAM,
    SOURCE.FACEBOOK,
    SOURCE.LINKEDIN,
  ],
  PHOTO: [],
  VIDEO: [SOURCE.YOUTUBE, SOURCE.TV, SOURCE.WEB_TV, SOURCE.NEWS],
  VERTICAL_VIDEO: [SOURCE.TIKTOK],
};

export type CoverProps = {
  className?: string;
  episode: Pick<Episode, "source" | "cover">;
  dumb?: boolean;
};

const Cover: React.FunctionComponent<CoverProps> = ({
  className,
  episode,
  dumb = false,
}) => {
  const { source } = episode || {};

  let inner = null;

  if (dumb) {
    inner = <GenericCover episode={episode} />;
  } else {
    switch (source) {
      case SOURCE.TIKTOK:
        inner = <TiktokCover episode={episode} />;
        break;
      case SOURCE.INSTAGRAM:
        inner = <InstagramCover episode={episode} />;
        break;
      case SOURCE.YOUTUBE:
        inner = <YoutubeCover episode={episode} />;
        break;
      default:
        inner = <GenericCover episode={episode} />;
    }
  }

  return (
    <div
      className={cx(styles.root, className, {
        [styles.video]: SIZES.VIDEO.includes(source),
        [styles.verticalVideo]: SIZES.VERTICAL_VIDEO.includes(source),
        [styles.square]: SIZES.SQUARE.includes(source),
        [styles.photo]: SIZES.PHOTO.includes(source),
      })}
    >
      {inner}
    </div>
  );
};

export default Cover;
